import { c as _c } from "react/compiler-runtime";
import cn from 'classnames';
import type { PresenceStatus } from '@sbt-web/network/types';
import styles from './index.module.scss';
interface Props {
  presenceText?: string;
  presenceStatus?: PresenceStatus;
}
export const PrivateUserOnlinePresence = t0 => {
  const $ = _c(5);
  const {
    presenceStatus,
    presenceText
  } = t0;
  if (!presenceStatus || !presenceText) {
    return;
  }
  const t1 = presenceStatus === "ONLINE";
  let t2;
  if ($[0] !== t1) {
    t2 = cn("body-text", "book", "small", styles.presence_status, {
      [styles.online]: t1
    });
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== presenceText || $[3] !== t2) {
    t3 = <p className={t2}>{presenceText}</p>;
    $[2] = presenceText;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};